import NotImplementedError from "../NotImplementedError.js";

/**
 *
 * @version 2026-09-01
 * @author Patrik Harag
 */
export default class ComponentPanel {

    getTabId() {
        throw new NotImplementedError();
    }

    getTabName() {
        throw new NotImplementedError();
    }

    createNode() {
        throw new NotImplementedError();
    }
}
